export function throwIfAlreadyLoaded(
  parentModule: unknown,
  moduleName: string,
) {
  if (parentModule) {
    throw new Error(
      `${moduleName} has already been loaded. Import ${moduleName} modules in the AppModule only.`,
    );
  }
}
